import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

class ItemCouponMessage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { statusMessages, userInfo } = this.props;

    const wrapperClasses = clsx({
      xMetaContainer:   true,
      xStatus:          true,
      xMessageGranted:  userInfo.isEligible && userInfo.isUnlock,
      xMessageUnlocked: userInfo.isEligible && !userInfo.isUnlock,
      xMessageLocked:   !userInfo.isEligible,
    });
    let message = statusMessages.available;
    message = userInfo.isEligible && userInfo.isUnlock ? statusMessages.granted : message;

    return (
      <If condition={!!message}>
        <div className={wrapperClasses}>
          <p className="xMeta xMessage">{message}</p>
        </div>
      </If>
    );
  }
}

ItemCouponMessage.propTypes = {
  statusMessages: PropTypes.object.isRequired,
  userInfo:       PropTypes.object.isRequired,
};

export default ItemCouponMessage;
